/**
 * T7a — o cartão "Meus testes" em Meu perfil. Aparece só para quem tem login VINCULADO a uma ficha de funcionário
 * (vínculo R0 do RH), com as duas flags ligadas — quem decide é o servidor (404 = o cartão não existe).
 * Mostra só os próprios resultados concluídos e válidos: "Ver resultado" e "Baixar PDF".
 */
import { Card } from '@/components/ui';
import { TestesDoFuncionario } from '@/components/testes/TestesDoFuncionario';
import { useMyFeatureFlag } from '@/lib/feature-flags-store';
import { useMeusTestes } from '@/lib/testes/testes-store';
import { TEXTOS } from '@/lib/testes/textos';

export function MeusTestesCard() {
  const rh = useMyFeatureFlag('MENU_RH_ENABLED');
  const testes = useMyFeatureFlag('TESTES_COMPORTAMENTAIS_ENABLED');
  const ligado = rh && testes;
  const { data } = useMeusTestes(ligado);
  if (!ligado || !data) return null;
  return (
    <Card variant="flat" className="mb-4 p-6" data-testid="meus-testes">
      <h2 className="mb-3 text-sm font-semibold text-ink-1 dark:text-ink-dark-1">{TEXTOS.meu_perfil.titulo}</h2>
      <TestesDoFuncionario testes={data} />
    </Card>
  );
}
